import { render, staticRenderFns } from "./BaseToolTip2.vue?vue&type=template&id=156cb0f9&scoped=true&"
import script from "./BaseToolTip2.vue?vue&type=script&lang=js&"
export * from "./BaseToolTip2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156cb0f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
